(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire7b1f"];
var parcelRegister = parcelRequire.register;
parcelRegister("kh3RP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $096119c34ab4d31d$export$2e2bcd8739ae039);

var $5uWxc = parcelRequire("5uWxc");

var $giM8N = parcelRequire("giM8N");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $5gQ0v = parcelRequire("5gQ0v");

var $9msyL = parcelRequire("9msyL");

var $7z3Sn = parcelRequire("7z3Sn");

var $boEq4 = parcelRequire("boEq4");

var $96bGs = parcelRequire("96bGs");

var $7gWUw = parcelRequire("7gWUw");

var $epZoF = parcelRequire("epZoF");

var $ahcAq = parcelRequire("ahcAq");

var $gUHWs = parcelRequire("gUHWs");

var $cZWl9 = parcelRequire("cZWl9");

var $4VmWu = parcelRequire("4VmWu");

var $52ejT = parcelRequire("52ejT");

var $kl0UU = parcelRequire("kl0UU");

const $096119c34ab4d31d$var$Header = ({ ot7_divisions: ot7_divisions })=>{
    const playoffsTab = [
        "playoffs",
        "Playoffs"
    ];
    const powerRankingsTab = [
        "power-rankings",
        "Power Rankings"
    ];
    const divisionTabs = ot7_divisions.map((d)=>[
            d.slug,
            d.name
        ]);
    const tabs = [
        playoffsTab,
        powerRankingsTab,
        ...divisionTabs
    ];
    // const tabs = [powerRankings];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $7z3Sn.default), {
        tabs: tabs,
        tabRoot: "/standings",
        ctaText: "Teams",
        ctaUrl: "/teams"
    }, "Standings");
};
const $096119c34ab4d31d$var$Standings = ()=>{
    let { phase: phase, section: divisionSlug } = (0, $bTBLz.useParams)();
    if (!divisionSlug) // Default to playoffs if no division slug is provided
    divisionSlug = "playoffs";
    const fetchDivisions = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_divisions/v1/public`,
        key: "ot7_divisions"
    });
    const divisions = fetchDivisions?.result.read();
    const fetchDivision = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_divisions/v1/public/${divisionSlug}`,
        key: "ot7_division"
    });
    const division = fetchDivision?.result.read();
    const isPlayoffs = divisionSlug === "playoffs" && phase !== "tournament";
    const isPlayoffsBrackets = divisionSlug === "playoffs" && phase === "tournament";
    const isPowerRankings = divisionSlug === "power-rankings";
    const isDivision = !isPlayoffs && !isPlayoffsBrackets && !isPowerRankings;
    if (isDivision && !division) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gUHWs.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $9msyL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Standings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($096119c34ab4d31d$var$Header, {
        ot7_divisions: divisions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, isPlayoffs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $52ejT.default), null), isPlayoffsBrackets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $4VmWu.default), null), isPowerRankings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $kl0UU.default), null), isDivision && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, divisionSlug && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Phase"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: `${(0, $epZoF.Urls).OvertimeImagesBaseUrl}/${division.logo_path}`
    }), division.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Secondary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Location"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "City"
    }, "Dallas, TX"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Date"
    }, "Mar 12 - Present")), divisionSlug == "golden-ticket" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "StandingsLink"
    }, phase === "tournament" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: `/standings/${divisionSlug}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconStandingsListSvg)
    }), "Standings") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: `/standings/${divisionSlug}/tournament`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconStandingsBracketSvg)
    }), "Bracket")))), phase === "tournament" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $cZWl9.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $boEq4.default), {
        showTies: divisionSlug == "golden-ticket" ? false : true,
        isGoldenTicket: divisionSlug == "golden-ticket"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Footnotes"
    }, divisionSlug != "golden-ticket" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Footnote"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $5uWxc.faTrophy),
        color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY,
        size: "2x"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Text"
    }, "Denotes Division Champ")), divisionSlug == "golden-ticket" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Footnote"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconGoldenTicketSvg),
        alt: "Golden Ticket"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Text"
    }, "Denotes Golden Ticket Winner"))))))));
};
var $096119c34ab4d31d$export$2e2bcd8739ae039 = $096119c34ab4d31d$var$Standings;

});
parcelRegister("boEq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1938cf90f32419$export$2e2bcd8739ae039);

var $5uWxc = parcelRequire("5uWxc");

var $giM8N = parcelRequire("giM8N");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $96bGs = parcelRequire("96bGs");

var $ahcAq = parcelRequire("ahcAq");

var $7gWUw = parcelRequire("7gWUw");

var $jGY54 = parcelRequire("jGY54");

var $epZoF = parcelRequire("epZoF");

var $gbPv6 = parcelRequire("gbPv6");

const $5b1938cf90f32419$var$Table = ({ showTies: showTies, isGoldenTicket: isGoldenTicket = false })=>{
    const { section: divisionSlug } = (0, $bTBLz.useParams)();
    // type standingsResult = { ot7_event: Ot7Event; ot7_games: Ot7Game[]; ot7_team_standings: teamStanding[] };
    const standingsFetch = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_www/v1/standings/public/${divisionSlug}`,
        key: "ot7_team_standings"
    });
    const ot7_team_standings = standingsFetch.result.read();
    const divisionFetch = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_divisions/v1/public/${divisionSlug}`,
        key: "ot7_division"
    });
    const ot7_division = divisionFetch.result.read();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "StandingsTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamsContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, "Team"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, "W"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, "L"), ot7_team_standings?.length > 0 ? ot7_team_standings.map((t, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2MgeJ.Fragment), {
            key: t.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Position"
        }, (showTies ? t.stringPosition : (index + 1).toString() ?? 0) || "-"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Name"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
            className: "inherit",
            href: `/teams/${t.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "TeamLogo",
            style: {
                backgroundColor: (0, $jGY54.colorFromInt)(t.primary_color)
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
            src: `${(0, $epZoF.Urls).OvertimeImagesBaseUrl}/${t.logo_path}`
        })), t.name, ot7_division.winner_ot7_team_id == t.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Winner"
        }, isGoldenTicket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
            src: (0, $7gWUw.imgIconGoldenTicketSvg),
            alt: "Golden Ticket"
        }), !isGoldenTicket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
            icon: (0, $5uWxc.faTrophy),
            color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY,
            size: "2x"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Record"
        }, t.wins ?? 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Record"
        }, t.losses ?? 0))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gbPv6.default), null)));
};
var $5b1938cf90f32419$export$2e2bcd8739ae039 = $5b1938cf90f32419$var$Table;

});

parcelRegister("cZWl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e43c91ef7d2cfb$export$2e2bcd8739ae039);

var $5uWxc = parcelRequire("5uWxc");

var $giM8N = parcelRequire("giM8N");

var $2MgeJ = parcelRequire("2MgeJ");

var $7gWUw = parcelRequire("7gWUw");

var $jGY54 = parcelRequire("jGY54");

var $epZoF = parcelRequire("epZoF");

var $96bGs = parcelRequire("96bGs");

const $13e43c91ef7d2cfb$var$getColumnInfo = ({ gameColumns: gameColumns })=>{
    const middleIndex = Math.floor(gameColumns.length / 2);
    const isOddLength = gameColumns.length % 2 !== 0;
    return gameColumns.map((column, index)=>{
        let bracketSide;
        if (isOddLength && index === middleIndex) bracketSide = "Center";
        else if (index < middleIndex) bracketSide = "Left";
        else bracketSide = "Right";
        return {
            games: column,
            size: column.length,
            bracketSide: bracketSide
        };
    });
};
const $13e43c91ef7d2cfb$var$_Team = ({ team: team })=>{
    return team ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `Team ${team.status}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Logo",
        style: {
            backgroundColor: team.backgroundColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: team.logo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamName"
    }, team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Score"
    }, team.score)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Team"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Logo",
        style: {
            backgroundColor: "#ffffff",
            padding: "4px",
            aspectRatio: "1/1"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgOt7LogoBlackSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamName"
    }, "TBD"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Score"
    }));
};
const $13e43c91ef7d2cfb$var$_Game = ({ game: game })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `GameDetails`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Title"
    }, game.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Teams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($13e43c91ef7d2cfb$var$_Team, {
        team: game.awayTeam
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Divider"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($13e43c91ef7d2cfb$var$_Team, {
        team: game.homeTeam
    }))));
};
const $13e43c91ef7d2cfb$var$GoldenTicketBracket = ()=>{
    const [bracketGames, setBracketGames] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState(null);
    (0, $2MgeJ.useEffect)(()=>{
        const fetchGames = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(`${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_www/ot7_bracket_games/v1/public`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setBracketGames(data.ot7_bracket_games);
            } catch (e) {
                setError("An unknown error occurred");
                console.error("Failed to fetch games:", e);
            } finally{
                setLoading(false);
            }
        };
        fetchGames();
    }, []);
    const ot7GameToGameParams = ({ name: name, ot7_game: ot7_game })=>{
        const homeTeam = ot7_game?.ot7_games_ot7_teams?.find((team)=>team.is_home_team)?.ot7_team;
        const homeTeamScore = ot7_game?.ot7_games_ot7_teams?.find((team)=>team.is_home_team)?.points;
        const awayTeam = ot7_game?.ot7_games_ot7_teams?.find((team)=>!team.is_home_team)?.ot7_team;
        const awayTeamScore = ot7_game?.ot7_games_ot7_teams?.find((team)=>!team.is_home_team)?.points;
        const homeStatus = ot7_game?.status != "confirmed" ? "Pending" : homeTeamScore > awayTeamScore ? "Winner" : "Loser";
        const awayStatus = ot7_game?.status != "confirmed" ? "Pending" : awayTeamScore > homeTeamScore ? "Winner" : "Loser";
        return {
            name: name,
            homeTeam: homeTeam ? {
                seed: null,
                logo: `${(0, $epZoF.Urls).OvertimeImagesBaseUrl}/${homeTeam.logo_path}`,
                name: homeTeam.name,
                score: homeTeamScore,
                status: homeStatus,
                backgroundColor: (0, $jGY54.colorFromInt)(homeTeam.primary_color)
            } : null,
            awayTeam: awayTeam ? {
                seed: null,
                logo: `${(0, $epZoF.Urls).OvertimeImagesBaseUrl}/${awayTeam.logo_path}`,
                name: awayTeam.name,
                score: awayTeamScore,
                status: awayStatus,
                backgroundColor: (0, $jGY54.colorFromInt)(awayTeam.primary_color)
            } : null
        };
    };
    const findAndMapGame = (allBracketGames, bracketGameName, displayName)=>{
        const foundBracketGame = allBracketGames.find((g)=>g.name === bracketGameName);
        const ot7Game = foundBracketGame?.ot7_game;
        return ot7GameToGameParams({
            name: displayName,
            ot7_game: ot7Game
        });
    };
    const playInAParams = findAndMapGame(bracketGames, "PlayInA", "Play-In");
    const playInBParams = findAndMapGame(bracketGames, "PlayInB", "Play-In");
    const quarterfinalsAParams = findAndMapGame(bracketGames, "QuarterfinalsA", "Quarterfinals");
    const quarterfinalsBParams = findAndMapGame(bracketGames, "QuarterfinalsB", "Quarterfinals");
    const quarterfinalsCParams = findAndMapGame(bracketGames, "QuarterfinalsC", "Quarterfinals");
    const quarterfinalsDParams = findAndMapGame(bracketGames, "QuarterfinalsD", "Quarterfinals");
    const semifinalsAParams = findAndMapGame(bracketGames, "SemifinalsA", "Semifinals");
    const semifinalsBParams = findAndMapGame(bracketGames, "SemifinalsB", "Semifinals");
    const championshipParams = findAndMapGame(bracketGames, "Championship", "Championship");
    // columns for the bracket
    const playInGameA = [
        playInAParams
    ];
    const quarterFinalGamesA = [
        quarterfinalsAParams,
        quarterfinalsBParams
    ];
    const semiFinalGamesA = [
        semifinalsAParams
    ];
    const finalGame = [
        championshipParams
    ];
    const semiFinalGamesB = [
        semifinalsBParams
    ];
    const quarterFinalGamesB = [
        quarterfinalsCParams,
        quarterfinalsDParams
    ];
    const playInGameB = [
        playInBParams
    ];
    // split into 2 different groups so that play in doesn't have to mix into the rest of the brackets
    const playInGameColumns = [
        playInGameA,
        [],
        [],
        [],
        playInGameB
    ];
    const gameColumns = [
        quarterFinalGamesA,
        semiFinalGamesA,
        finalGame,
        semiFinalGamesB,
        quarterFinalGamesB
    ];
    // add column info to add styles for connecting lines
    const playInGameColumnsInfo = $13e43c91ef7d2cfb$var$getColumnInfo({
        gameColumns: playInGameColumns
    });
    const gameColumnsInfo = $13e43c91ef7d2cfb$var$getColumnInfo({
        gameColumns: gameColumns
    });
    const tables = [
        playInGameColumnsInfo,
        gameColumnsInfo
    ];
    const isFinalComplete = championshipParams?.awayTeam?.status === "Winner" || championshipParams?.homeTeam?.status === "Winner";
    const finalChampion = isFinalComplete && championshipParams?.awayTeam?.status === "Winner" ? championshipParams?.awayTeam?.name : isFinalComplete && championshipParams?.homeTeam?.status === "Winner" ? championshipParams?.homeTeam?.name : null;
    if (!bracketGames.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GoldenTicketBracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "BracketContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Loading"
    }, "Loading...")));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GoldenTicketBracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `BracketContainer Container-Size-${gameColumnsInfo.length}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "HeroImage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgOt7GoldenTicketHeroWebp)
    })), finalChampion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ChampionTeam"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Title"
    }, "Champion"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Winner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $5uWxc.faTrophy),
        color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY,
        size: "2x"
    }), finalChampion)), tables.map((table, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, {
            key: `game-table-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, {
            key: `game-table-${index}`
        }, table.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: `BracketColumn Size-${column.size} ${index == 0 ? "First" : index == table.length - 1 ? "Last" : ""}`,
                key: `game-column-${index}`
            }, column.games.map((game, gameIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: `Game ${column.bracketSide}-Side`,
                    key: `game-${index}-${gameIndex}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Lines-Before"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Line"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($13e43c91ef7d2cfb$var$_Game, {
                    game: game
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Line"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Lines-After"
                })))))), index == 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, {
            key: `game-table-vertical-lines-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn First`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "VerticalLine First"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn Last`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "VerticalLine Last"
        })))))));
};
var $13e43c91ef7d2cfb$export$2e2bcd8739ae039 = $13e43c91ef7d2cfb$var$GoldenTicketBracket;

});

parcelRegister("4VmWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $072411f2d848dbec$export$2e2bcd8739ae039);

var $5uWxc = parcelRequire("5uWxc");

var $giM8N = parcelRequire("giM8N");

var $2MgeJ = parcelRequire("2MgeJ");

var $7gWUw = parcelRequire("7gWUw");

var $jGY54 = parcelRequire("jGY54");

var $epZoF = parcelRequire("epZoF");

var $96bGs = parcelRequire("96bGs");

const $072411f2d848dbec$var$getColumnInfo = ({ gameColumns: gameColumns })=>{
    const middleIndex = Math.floor(gameColumns.length / 2);
    const isOddLength = gameColumns.length % 2 !== 0;
    return gameColumns.map((column, index)=>{
        let bracketSide;
        if (isOddLength && index === middleIndex) bracketSide = "Center";
        else if (index < middleIndex) bracketSide = "Left";
        else bracketSide = "Right";
        return {
            games: column,
            size: column.length,
            bracketSide: bracketSide
        };
    });
};
const $072411f2d848dbec$var$_Team = ({ team: team })=>{
    return team ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `Team ${team.status}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Logo",
        style: {
            backgroundColor: team.backgroundColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: team.logo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamName"
    }, team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Score"
    }, team.score)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Team"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Logo",
        style: {
            backgroundColor: "#ffffff",
            padding: "4px",
            aspectRatio: "1/1"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgOt7LogoBlackSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamName"
    }, "TBD"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Score"
    }));
};
const $072411f2d848dbec$var$_Game = ({ game: game })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `GameDetails`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Title"
    }, game.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Teams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($072411f2d848dbec$var$_Team, {
        team: game.awayTeam
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Divider"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($072411f2d848dbec$var$_Team, {
        team: game.homeTeam
    }))));
};
const $072411f2d848dbec$var$PlayoffsBracket = ()=>{
    const [bracketGames, setBracketGames] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState(null);
    (0, $2MgeJ.useEffect)(()=>{
        const fetchGames = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(`${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_www/ot7_bracket_games/v1/public`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setBracketGames(data.ot7_bracket_games);
            } catch (e) {
                setError("An unknown error occurred");
                console.error("Failed to fetch games:", e);
            } finally{
                setLoading(false);
            }
        };
        fetchGames();
    }, []);
    const ot7GameToGameParams = ({ name: name, ot7_game: ot7_game })=>{
        const homeTeam = ot7_game?.ot7_games_ot7_teams?.find((team)=>team.is_home_team)?.ot7_team;
        const homeTeamScore = ot7_game?.ot7_games_ot7_teams?.find((team)=>team.is_home_team)?.points;
        const awayTeam = ot7_game?.ot7_games_ot7_teams?.find((team)=>!team.is_home_team)?.ot7_team;
        const awayTeamScore = ot7_game?.ot7_games_ot7_teams?.find((team)=>!team.is_home_team)?.points;
        const homeStatus = ot7_game?.status != "confirmed" ? "Pending" : homeTeamScore > awayTeamScore ? "Winner" : "Loser";
        const awayStatus = ot7_game?.status != "confirmed" ? "Pending" : awayTeamScore > homeTeamScore ? "Winner" : "Loser";
        return {
            name: name,
            homeTeam: homeTeam ? {
                seed: null,
                logo: `${(0, $epZoF.Urls).OvertimeImagesBaseUrl}/${homeTeam.logo_path}`,
                name: homeTeam.name,
                score: homeTeamScore,
                status: homeStatus,
                backgroundColor: (0, $jGY54.colorFromInt)(homeTeam.primary_color)
            } : null,
            awayTeam: awayTeam ? {
                seed: null,
                logo: `${(0, $epZoF.Urls).OvertimeImagesBaseUrl}/${awayTeam.logo_path}`,
                name: awayTeam.name,
                score: awayTeamScore,
                status: awayStatus,
                backgroundColor: (0, $jGY54.colorFromInt)(awayTeam.primary_color)
            } : null
        };
    };
    const findAndMapGame = (allBracketGames, bracketGameName, displayName)=>{
        const foundBracketGame = allBracketGames.find((g)=>g.name === bracketGameName);
        const ot7Game = foundBracketGame?.ot7_game;
        return ot7GameToGameParams({
            name: displayName,
            ot7_game: ot7Game
        });
    };
    const playInAParams = findAndMapGame(bracketGames, "PlayInA", "Play-In");
    const playInBParams = findAndMapGame(bracketGames, "PlayInB", "Play-In");
    const quarterfinalsAParams = findAndMapGame(bracketGames, "QuarterfinalsA", "Quarterfinals");
    const quarterfinalsBParams = findAndMapGame(bracketGames, "QuarterfinalsB", "Quarterfinals");
    const quarterfinalsCParams = findAndMapGame(bracketGames, "QuarterfinalsC", "Quarterfinals");
    const quarterfinalsDParams = findAndMapGame(bracketGames, "QuarterfinalsD", "Quarterfinals");
    const semifinalsAParams = findAndMapGame(bracketGames, "SemifinalsA", "Semifinals");
    const semifinalsBParams = findAndMapGame(bracketGames, "SemifinalsB", "Semifinals");
    const championshipParams = findAndMapGame(bracketGames, "Championship", "Championship");
    // columns for the bracket
    const playInGameA = [
        playInAParams
    ];
    const quarterFinalGamesA = [
        quarterfinalsAParams,
        quarterfinalsBParams
    ];
    const semiFinalGamesA = [
        semifinalsAParams
    ];
    const finalGame = [
        championshipParams
    ];
    const semiFinalGamesB = [
        semifinalsBParams
    ];
    const quarterFinalGamesB = [
        quarterfinalsCParams,
        quarterfinalsDParams
    ];
    const playInGameB = [
        playInBParams
    ];
    // split into 2 different groups so that play in doesn't have to mix into the rest of the brackets
    const playInGameColumns = [
        playInGameA,
        [],
        [],
        [],
        playInGameB
    ];
    const gameColumns = [
        quarterFinalGamesA,
        semiFinalGamesA,
        finalGame,
        semiFinalGamesB,
        quarterFinalGamesB
    ];
    // add column info to add styles for connecting lines
    const playInGameColumnsInfo = $072411f2d848dbec$var$getColumnInfo({
        gameColumns: playInGameColumns
    });
    const gameColumnsInfo = $072411f2d848dbec$var$getColumnInfo({
        gameColumns: gameColumns
    });
    const tables = [
        playInGameColumnsInfo,
        gameColumnsInfo
    ];
    const isFinalComplete = championshipParams?.awayTeam?.status === "Winner" || championshipParams?.homeTeam?.status === "Winner";
    const finalChampion = isFinalComplete && championshipParams?.awayTeam?.status === "Winner" ? championshipParams?.awayTeam?.name : isFinalComplete && championshipParams?.homeTeam?.status === "Winner" ? championshipParams?.homeTeam?.name : null;
    if (!bracketGames.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayoffsBracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "BracketContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Loading"
    }, "Loading...")));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Playoffs Phase"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Primary"
    }, "Group Stage"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Secondary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Location"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "City"
    }, "Miami, FL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Date"
    }, "Fri, Jun 27 - Sat, Jun 28")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "StandingsLink",
        href: "/standings/playoffs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconStandingsBracketSvg)
    }), "Standings")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayoffsBracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `BracketContainer Container-Size-${gameColumnsInfo.length}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "HeroImage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgOt7PlayoffsBracketPng)
    })), finalChampion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ChampionTeam"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Title"
    }, "Champion"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Winner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $5uWxc.faTrophy),
        color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY,
        size: "2x"
    }), finalChampion)), tables.map((table, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, {
            key: `game-table-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, {
            key: `game-table-${index}`
        }, table.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: `BracketColumn Size-${column.size} ${index == 0 ? "First" : index == table.length - 1 ? "Last" : ""}`,
                key: `game-column-${index}`
            }, column.games.map((game, gameIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: `Game ${column.bracketSide}-Side`,
                    key: `game-${index}-${gameIndex}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Lines-Before"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Line"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($072411f2d848dbec$var$_Game, {
                    game: game
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Line"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                    className: "Lines-After"
                })))))), index == 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, {
            key: `game-table-vertical-lines-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn First`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "VerticalLine First"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `BracketColumn Last`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "VerticalLine Last"
        }))))))));
};
var $072411f2d848dbec$export$2e2bcd8739ae039 = $072411f2d848dbec$var$PlayoffsBracket;

});


})();
//# sourceMappingURL=Standings.b26ff1c8.js.map
